import { render, staticRenderFns } from "./heroBlock.vue?vue&type=template&id=06371b90&"
import script from "./heroBlock.vue?vue&type=script&lang=js&"
export * from "./heroBlock.vue?vue&type=script&lang=js&"
import style0 from "./heroBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports